import { render, staticRenderFns } from "./Especificacoes.vue?vue&type=template&id=7a36f6ec&scoped=true&"
import script from "./Especificacoes.vue?vue&type=script&lang=js&"
export * from "./Especificacoes.vue?vue&type=script&lang=js&"
import style0 from "./Especificacoes.vue?vue&type=style&index=0&id=7a36f6ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36f6ec",
  null
  
)

export default component.exports